import React, { useEffect } from 'react';
import { useKeycloak } from '../../providers/KeycloakProvider';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setUser, setAuthToken } from './authSlice';
import { Box, CircularProgress, Typography, Button, Card, CardContent } from '@mui/material';


import { Link } from '@mui/material';

//login Keycloak
// Gestion automatique : Récupère les infos utilisateur après connexion
// Redirection intelligente : Retourne à la page demandée


const LoginKeycloak = () => {
  const { keycloak, initialized } = useKeycloak();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoggingIn, setIsLoggingIn] = React.useState(false);

  const from = location.state?.from?.pathname || '/';

  const handleKeycloakLogin = () => {
    if (initialized && !keycloak.authenticated) {
      setIsLoggingIn(true);
      keycloak.login();
    }
  };


  useEffect(() => {
    if (initialized && keycloak.authenticated) {
      const getUserInfo = async () => {
        try {
          const token = await keycloak.updateToken(30);
          const userInfo = {
            id: keycloak.tokenParsed.sub,
            email: keycloak.tokenParsed.email,
            name: keycloak.tokenParsed.name,
            roles: keycloak.tokenParsed.resource_access?.['biotech-access-api']?.roles || [],
            realmRoles: keycloak.tokenParsed.realm_access?.roles || [],
            hasItRole: keycloak.tokenParsed.realm_access?.roles?.includes('it') || false,
          };

          dispatch(setUser(userInfo));
          dispatch(setAuthToken(token));

          navigate(from, { replace: true });
        } catch (error) {
          keycloak.login();
        }
      };

      getUserInfo();
    }
  }, [initialized, keycloak, navigate, from, dispatch]);

  if (!initialized || isLoggingIn) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        sx={{ backgroundColor: '#f5f5f5' }}
      >
        <CircularProgress />
        <Typography variant="h6" style={{ marginTop: 16 }}>
          {!initialized ? 'Initialisation de l\'authentification...' : 'Connexion en cours...'}
        </Typography>
      </Box>
    );
  }


  if (initialized && !keycloak.authenticated) {
    return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      sx={{ backgroundColor: '#f5f5f5' }}
    >
      <Card
        sx={{
          maxWidth: 400,
          width: '100%',
          mx: 2,
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <CardContent sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
            Bienvenue
          </Typography>
          
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            Connectez-vous pour accéder à votre espace
          </Typography>

          <Button
            variant="contained"
            size="large"
            fullWidth
            onClick={handleKeycloakLogin}
            sx={{
              py: 1.5,
              px: 3,
              borderRadius: 2,
              backgroundColor: '#1976d2',
              '&:hover': {
                backgroundColor: '#1565c0',
              },
            }}
            startIcon={
              <Box
                sx={{
                  width: 24,
                  height: 24,
                  borderRadius: '50%',
                  backgroundColor: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#1976d2',
                  fontWeight: 'bold',
                }}
              >
                !
              </Box>
            }
          >
            Se connecter avec Keycloak
          </Button>

          <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
            En vous connectant, vous acceptez nos{' '}
            <Link href="#" underline="hover" color="primary">
              conditions d'utilisation
            </Link>
          </Typography>
        </CardContent>
      </Card>
    </Box>
    );
  }


  return null;
};

export default LoginKeycloak;
